import axios from "axios"
import * as yup from "yup"
import GlobalVariable from "./global"
import { isUserLoggedIn } from "@utils"
// Centralized user fetch function
const getCurrentUser = () => isUserLoggedIn() || null
// Returns full user object
const getUser = () => getCurrentUser()

const baseApiUrl = GlobalVariable.BASE_API_URL
const headerText = GlobalVariable.headerText
const DocusignTitle = 'You have received an email from DocuSign with the link to the Annual Declaration for review. Please carefully review the Annual Declaration and sign it via DocuSign. Refresh this page once the signature has been completed.'
const DocusignTitleDL = 'You have received an email from DocuSign with the link to the Declaration Letter for review. Please carefully review the Declaration Letter and sign it via DocuSign. Refresh this page once the signature has been completed.'
const InvoicePaymentModes = [{ value: 1, label: 'WireTransfer' }, { value: 2, label: 'CreditCard' }, { value: 3, label: 'PayLater' }, { value: 4, label: 'GPay' }, { value: 5, label: 'ApplePay' }]
const InvoicePaymentStatus = [{ value: 1, label: 'Pending' }, { value: 2, label: 'Processed' }, { value: 3, label: 'Failed' }]
const WOStatus = [{ value: 1, label: 'Active' }, { value: 2, label: 'Deleted' }, { value: 3, label: 'Cancelled' }]
const errorresponse = "Something Went Wrong. Please approach technical team."
const datesList = ["st", "nd", "rd", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th", "th", "st"]
const monthnames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
const fullmonthnames = [
  { key: '01', value: 'Jan' },
  { key: '02', value: 'Feb' },
  { key: '03', value: 'Mar' },
  { key: '04', value: 'Apr' },
  { key: '05', value: 'May' },
  { key: '06', value: 'Jun' },
  { key: '07', value: 'Jul' },
  { key: '08', value: 'Aug' },
  { key: '09', value: 'Sep' },
  { key: '10', value: 'Oct' },
  { key: '11', value: 'Nov' },
  { key: '12', value: 'Dec' }
]

const offices = [
  { regionalId: 1, label: "Cyprus", value: "limassol.corporate@liscr.com" },
  { regionalId: 2, label: "Istanbul", value: "istanbul@liscr.com" },
  { regionalId: 3, label: "Piraeus", value: "corporate@liscr.gr" },
  { regionalId: 4, label: "Miami", value: "corporate@liscr.com2" },
  { regionalId: 5, label: "Virginia", value: "corporate@liscr.com11" },
  { regionalId: 6, label: "Argentina", value: null },
  { regionalId: 7, label: "Brazil", value: null },
  { regionalId: 8, label: "China", value: null },
  { regionalId: 9, label: "Dubai", value: null },
  { regionalId: 10, label: "Greece", value: null },
  { regionalId: 11, label: "Hamburg", value: null },
  { regionalId: 12, label: "Hongkong", value: null },
  { regionalId: 13, label: "Japan", value: null },
  { regionalId: 14, label: "Korea", value: null },
  { regionalId: 15, label: "Leer", value: null },
  { regionalId: 16, label: "London", value: null },
  { regionalId: 17, label: "Manila", value: null },
  { regionalId: 18, label: "Panama", value: null },
  { regionalId: 19, label: "Philippines", value: null },
  { regionalId: 20, label: "Piraeus", value: null },
  { regionalId: 21, label: "Shanghai", value: null },
  { regionalId: 22, label: "Singapore", value: null },
  { regionalId: 23, label: "South Korea", value: null },
  { regionalId: 24, label: "Taiwan", value: null },
  { regionalId: 25, label: "Turkey", value: null },
  { regionalId: 26, label: "USA", value: null },
  { regionalId: 27, label: "GLOBAL", value: null }
].filter((item) => item.value)

const specialCharacterErrorMessage = "Special Character '#' is not allowed"
const hashCharacterPattern = '#'
const postalCodeErrorMessaage = 'Postal Code/Zip Code must be between 4 to 8 characters'
const StepperName = "Pending Submission"
const CreditCardNote = 'Please note that a 4% Convenience Fee is charged based on the transaction total.'
const specialCharacterPattern = /^[^#]*$/
const preorderInvoiveTitle = 'Please save the address changes before proceeding further by clicking the Save Address button'
const responsibleOffices = [
  { value: 1, label: 'North America Office', email: 'ngarikapati@liscr.com' },
  { value: 2, label: 'Europe Office', email: 'kbejawada@liscr.com' },
  { value: 3, label: 'Asia Pacific Office', email: 'snarala@liscr.com' },
  { value: 4, label: 'South America Office', email: 'dmedikonda@liscr.com' },
  { value: 5, label: 'Middle East Office', email: 'danumolu@liscr.com' },
  { value: 6, label: 'Africa Office', email: 'sgubba@liscr.com' },
  { value: 7, label: 'Central America Office', email: 'jnadipalli@liscr.com' },
  { value: 8, label: 'Australia Office', email: 'nvunnam@liscr.com' },
  { value: 9, label: 'Canada Office', email: 'rparimi@liscr.com' },
  { value: 10, label: 'UK Office', email: 'nghattamaneni@liscr.com' }
]

const myDecodeURIComponent = (encodedValue) => {
  // let originalString = decodeURIComponent(encodedValue)
  // if (originalString.includes('%7E')) {
  //originalString = originalString.replace(/%7E/g, '~')
  //}
  //if (originalString.includes('%21')) {
  // originalString = originalString.replace(/%21/g, '!')
  //}
  //if (originalString.includes('%2A')) {
  //originalString = originalString.replace(/%2A/g, '*')
  //}
  //if (originalString.includes('%28')) {
  // originalString = originalString.replace(/%28/g, '(')
  //}
  //if (originalString.includes('%29')) {
  //originalString = originalString.replace(/%29/g, ')')
  //}
  //if (originalString.includes('%2D')) {
  //originalString = originalString.replace(/%2D/g, '-')
  //}
  //if (originalString.includes('%5F')) {
  //originalString = originalString.replace(/%5F/g, '_')
  //}
  //return originalString
  return decodeURIComponent(encodedValue)
}
const CreditCardpercentage = 0.04

const PaymentInstructions = `
 <div><h2 class='invoice-inst' style={{ margin: '0px' }}>Note: <span class="invoice-inst-parag" >Please also add the work order number in your wire transfer notes </span></h2>
 <div style="text-align:center;font-size:15px;font-family:Times New Roman!important;font-weight:600;color:#000;margin-top:10px;text-decoration:underline">PAYMENT INSTRUCTIONS </div>
 <div style="font-family: Times New Roman !important;font-size: 13px;
    color: #000">
    <div style="display:flex;justify-content:space-between;margin:10px 0;line-height:16px">
              <div style="width:48%;padding-top:0">
                <div style="font-weight:700;color:red;text-align:center">Wire Transfers&nbsp; <u>outside</u>&nbsp;the USA </div>
                <div style="display:flex;margin-top:8px;margin-bottom:5px">
                  <div style="width:35%">Bank Name:</div>
                  <div style="width:65%;color:#00f">JPMorgan Chase New York, NY 10017 USA</div>
                </div>
                <div style="display:flex;margin-bottom:5px">
                  <div style="width:35%">Swift Code:</div>
                  <div style="width:65%">CHASUS33</div>
                </div>
                <div style="display:flex;margin-bottom:5px">
                  <div>Beneficiary Account Number: 527288537</div>
                </div>
                <div style="display:flex">
                  <div style="width:35%">Beneficiary Name:</div>
                  <div style="width:65%">LISCR - The LISCR Trust Company</div>
                </div>
              </div>
              <div style="width:48%;padding-top:0">
                <div style="font-weight:700;color:red;text-align:center">Wire Transfers&nbsp; <u>within</u>&nbsp;the USA </div>
                <div style="display:flex;margin-bottom:5px;margin-top:8px">
                  <div style="width:35%">Bank Name:</div>
                  <div style="width:65%;color:#00f">JPMorgan Chase New York, NY 10017 USA</div>
                </div>
                <div style="display:flex;margin-bottom:5px">
                  <div style="width:35%">ABA Number:</div>
                  <div style="width:65%">021000021</div>
                </div>
                <div style="display:flex;margin-bottom:0">
                  <div>Beneficiary Account Number: 527288537</div>
                </div>
                <div style="display:flex">
                  <div style="width:35%">Beneficiary Name:</div>
                  <div style="width:65%">LISCR - The LISCR Trust Company</div>
                </div>
              </div>
            </div>
            <div style="text-align:center;margin:0 0;font-weight:600">OR</div>
            <div style="display:flex;justify-content:space-between;margin:0 0;line-height:16px">
              <div style="width:48%;padding:10px">
                <div style="display:flex;margin-bottom:5px">
                  <div style="width:35%">Bank Name:</div>
                  <div style="width:65%;color:#00f">Bank of America N.A. <br>8300 Greensboro Dr. Suite 360 <br>McLean, VA 22102, USA </div>
                </div>
                <div style="display:flex;margin-bottom:5px">
                  <div style="width:35%">Swift Code:</div>
                  <div style="width:65%">BOFAUS3N</div>
                </div>
                <div style="display:flex;margin-bottom:5px">
                  <div style="width:100%">Beneficiary Account Number: 435059558233</div>
                </div>
                <div style="display:flex">
                  <div style="width:35%">Beneficiary Name:</div>
                  <div style="width:65%">LISCR - The LISCR Trust Company</div>
                </div>
              </div>
              <div style="width:48%;padding:10px">
                <div style="display:flex;margin-bottom:5px">
                  <div style="width:35%">Bank Name:</div>
                  <div style="width:65%;color:#00f">Bank of America N.A. <br>8300 Greensboro Dr. Suite 360 <br>McLean, VA 22102, USA </div>
                </div>
                <div style="display:flex;margin-bottom:5px">
                  <div style="width:35%">ABA Number:</div>
                  <div style="width:65%">026009593</div>
                </div>
                <div style="display:flex;margin-bottom:5px">
                  <div style="width:100%">Beneficiary Account Number: 435059558233</div>
                </div>
                <div style="display:flex">
                  <div style="width:35%">Beneficiary Name:</div>
                  <div style="width:65%">LISCR - The LISCR Trust Company</div>
                </div>
              </div>
            </div></div>
<div style="margin-top:10px">
  <span style="color:#000;font-size:13px;font-family:Times New Roman!important;font-weight:700">Payment to LISCR by Check/Bank Draft:</span>
  <span style="font-size:12px;font-family:Times New Roman!important;font-weight:500;padding-left:2px;color:#000">LISCR, LLC 22980 Indian Creek Drive, Suite 200, Dulles, VA 20166; Check/Bank Draft must be in USD and drawn from a US bank</span>
</div>
 </div>`

const entityMappings = [
  { code: "C", name: "CORP" },
  { code: "F", name: "FME" },
  { code: "LLC", name: "LLC" },
  { code: "LOP", name: "LOP" },
  { code: "LP", name: "LP" },
  { code: "NFP", name: "NFP" },
  { code: "P", name: "P" },
  { code: "PF", name: "PF" },
  { code: "RN", name: "ReserveName" }
]

const stepperValue = (stageVal, stageName, totalStages, temp = false) => {
  if (totalStages === 6) {
    if (stageVal === 3) {
      return StepperName
    } else {
      return stageName
    }
  } else if (totalStages === 4 && temp === true) {
    if (stageVal === 2) {
      return StepperName
    } else {
      return stageName
    }
  } else if (totalStages === 5) {
    if (stageVal === 2) {
      return StepperName
    } else {
      return stageName
    }
  } else if (totalStages === 7) {
    if (stageVal === 4) {
      return StepperName
    } else {
      return stageName
    }
  }

}

const addResponseInterceptor = async (axiosInstance) => {
  axiosInstance.interceptors.response.use((response) => {
    return response
  }, async function (error) {
    const originalRequest = error.config
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      const access_token = error.response.headers['x-auth-token']
      const refresh_token = error.response.headers['x-refresh-token']
      localStorage.setItem("token", access_token)
      localStorage.setItem("refresh_token", refresh_token)
      originalRequest.headers['Authorization'] = `Bearer ${access_token}`
      return axiosInstance(originalRequest)
    }
    return Promise.reject(error)
  })
}

const postalCodeMin = 4
const postalCodeMax = 8
export const DefaultConfig = () => {
  let authAxios = null
  let authAxiosMulti = null
  if (localStorage.getItem('token')) {
    const localStorageToken = localStorage.getItem('token')
    const refreshToken = localStorage.getItem('refresh_token')
    authAxios = axios.create({
      baseURL: baseApiUrl,
      headers: { Authorization: `Bearer ${localStorageToken}`, "x-refresh-token": refreshToken },
      withCredentials: true
    })
    addResponseInterceptor(authAxios)
    authAxiosMulti = axios.create({
      baseURL: baseApiUrl,
      headers: {
        Authorization: `Bearer ${localStorageToken}`,
        "Content-Type": "multipart/form-data",
        "x-refresh-token": refreshToken
      },
      withCredentials: true

    })
    addResponseInterceptor(authAxiosMulti)
  }

  const sorter = (sortname, sortorder, filteredData) => {
    const sortData = filteredData
    sortData.sort((a, b) => {
      if (typeof a[sortname] === "number" && typeof b[sortname] === "number") {
        if (sortorder === "asc") {
          return parseInt(b[sortname]) > parseInt(a[sortname]) ? 1 : parseInt(b[sortname]) < parseInt(a[sortname]) ? -1 : 0
        } else {
          return parseInt(a[sortname]) > parseInt(b[sortname]) ? 1 : parseInt(a[sortname]) < parseInt(b[sortname]) ? -1 : 0
        }
      } else if (
        typeof a[sortname] === "string" && typeof b[sortname] === "string") {
        if (sortorder === "asc") {
          return a[sortname].toLowerCase() > b[sortname].toLowerCase() ? 1 : a[sortname].toLowerCase() < b[sortname].toLowerCase() ? -1 : 0
        } else {
          return b[sortname].toLowerCase() > a[sortname].toLowerCase() ? 1 : b[sortname].toLowerCase() < a[sortname].toLowerCase() ? -1 : 0
        }
      } else {
        if (sortorder === "asc") {
          return a[sortname] > b[sortname] ? 1 : a[sortname] < b[sortname] ? -1 : 0
        } else {
          return b[sortname] > a[sortname] ? 1 : b[sortname] < a[sortname] ? -1 : 0
        }
      }
    })
    return sortData
  }

  function sortByLabel(arr) {
    return arr.sort((a, b) => {
      if (a.label.trim() < b.label.trim()) return -1
      if (a.label.trim() > b.label.trim()) return 1
      return 0
    })
  }

  const ReplaceString = (value) => {
    if (value) {
      return new Date(value.replace(/(\d+)(st|nd|rd|th)/, '$1'))
    }
    return ''
  }

  const DateFormat = (value) => {
    if (value) {
      const monthname = monthnames[new Date(value).getMonth()]
      const datevalue = `0${new Date(value).getDate()}`.slice(-2)
      const yearvalue = new Date(value).getFullYear()
      return `${datevalue}-${monthname}-${yearvalue}`
    } else {
      return ""
    }
  }

  const StringtoDateMonthYearFormat = (valueDate) => {
    if (valueDate) {
      const splitString = valueDate.split("-")
      if (splitString.length === 3) {
        const datevalue = splitString[0]
        const findMonth = fullmonthnames.find(find => find.key === splitString[1])
        let monthname = ''
        if (findMonth) {
          monthname = findMonth.value
        }
        const yearvalue = splitString[2]
        return `${datevalue}-${monthname}-${yearvalue}`
      }
    }
    return ""
  }

  const requestByValidationMessage = "Attention is a required field"

  const YearMonthDateFormatSplit = (value) => {
    if (value) {
      const splitDate = value.split('T')[0]
      if (splitDate) {
        const splitString = splitDate.split("-")
        if (splitString.length === 3) {
          const yearvalue = splitString[0]
          const datevalue = splitString[2]
          return `${datevalue} ${monthnames[Number(splitString[1]) - 1]} ${yearvalue}`
        }
      }
      return ""
    }
    return ""
  }

  const YearMonthDateFormat = (value) => {
    if (value) {
      // const splitDateFormat = value.split("T")
      // const splitDate = splitDateFormat.length > 0 ? splitDateFormat[0] : ''
      // if (splitDate) {
      //   const splitString = splitDate.split("-")
      //   if (splitString.length === 3) {
      //     const yearvalue = splitString[0]
      //     const findMonth = fullmonthnames.find(find => find.key === splitString[1])
      //     let monthname = ''
      //     if (findMonth) {
      //       monthname = findMonth.value
      //     }
      //     const datevalue = splitString[2]
      //     return `${monthname} ${datevalue && datevalue.replace(/^0/, '')}${datesList[datevalue - 1]}, ${yearvalue}`
      //   }
      // }
      const date = new Date(value)

      // Get the day, month, and year components
      let day = date.getDate()
      const monthIndex = date.getMonth()
      const year = date.getFullYear()
      if (day < 10) {
        day = `0${day}`
      }
      // Format the date
      const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`

      return formattedDate
    }
    return ""
  }

  const MonthDateYear = (value) => {
    if (value) {
      // const splitDateFormat = value.split("T")
      // const splitDate = splitDateFormat.length > 0 ? splitDateFormat[0] : ''
      // if (splitDate) {
      //   const splitString = splitDate.split("-")
      //   if (splitString.length === 3) {
      //     const yearvalue = splitString[0]
      //     const findMonth = fullmonthnames.find(find => find.key === splitString[1])
      //     let monthname = ''
      //     if (findMonth) {
      //       monthname = findMonth.value
      //     }
      //     const datevalue = splitString[2]
      //     return `${monthname} ${datevalue && datevalue.replace(/^0/, '')}${datesList[datevalue - 1]}, ${yearvalue}`
      //   }
      // }
      const date = new Date(value)

      // Get the day, month, and year components
      let day = date.getDate()
      const monthIndex = date.getMonth()
      const year = date.getFullYear()
      if (day < 10) {
        day = `0${day}`
      }
      // Format the date
      const formattedDate = `${monthnames[monthIndex]} ${day}, ${year}`

      return formattedDate
    }
    return ""
  }

  const customCss = {
    'font-size': '14px',
    'font-weight': '400',
    color: '#262626 !important',
    padding: ' 0.571rem 1rem',
    'background-color': '#fff',
    border: '1px solid #d8d6de',
    'border-radius': '0.357rem'
  }
  const invalidCss = {
    'border-color': '#EF3340'
  }
  const validCss = {
    'border-color': '#d8d6de'
  }

  const getESTDate = () => {
    // Create current date
    const now = new Date()

    // Convert to EST (UTC-5 or UTC-4 depending on daylight saving)
    const estDate = new Date(now.toLocaleString("en-US", { timeZone: "America/New_York" }))

    return estDate
  }

  const DateConversion = (dateStr) => {
    if (dateStr) {
      // Create a Date object from the input string
      const date = new Date(dateStr)

      // Get the day, month, and year components
      let day = date.getDate()
      const monthIndex = date.getMonth()
      const year = date.getFullYear()
      if (day < 10) {
        day = `0${day}`
      }
      // Format the date
      const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`

      return formattedDate
    }
    return ''
    // if (dateStr) {
    //   // Convert to Date object
    //   const date = new Date(dateStr)

    //   // Custom function to add ordinal suffix
    //   function addOrdinalSuffix(day) {
    //     if (day >= 11 && day <= 13) {
    //       return `${day}th`
    //     }

    //     const lastDigit = day % 10
    //     switch (lastDigit) {
    //       case 1:
    //         return `${day}st`
    //       case 2:
    //         return `${day}nd`
    //       case 3:
    //         return `${day}rd`
    //       default:
    //         return `${day}th`
    //     }
    //   }

    //   // Format date and time
    //   const formattedDate = date.toLocaleDateString("en-US", {
    //     month: "short",
    //     day: "numeric",
    //     year: "numeric"
    //   })

    //   // Extract day from the formatted date
    //   const day = formattedDate.match(/\d+/)[0]

    //   // Add ordinal suffix to the day
    //   const ordinalDay = addOrdinalSuffix(day)

    //   // Combine the formatted date, ordinal day, and formatted time
    //   const formattedDateTime = `${formattedDate.replace(/\d+/, ordinalDay)}`
    //   return formattedDateTime
    // }
    // return ''
  }

  const DateTimeConversion = (dateStr) => {
    if (dateStr) {
      // // Convert to Date object
      // const date = new Date(dateStr)

      // // Custom function to add ordinal suffix
      // function addOrdinalSuffix(day) {
      //   if (day >= 11 && day <= 13) {
      //     return `${day}th`
      //   }

      //   const lastDigit = day % 10
      //   switch (lastDigit) {
      //     case 1:
      //       return `${day}st`
      //     case 2:
      //       return `${day}nd`
      //     case 3:
      //       return `${day}rd`
      //     default:
      //       return `${day}th`
      //   }
      // }

      // // Format date and time
      // const formattedDate = date.toLocaleDateString("en-US", {
      //   month: "short",
      //   day: "numeric",
      //   year: "numeric"
      // })
      // const formattedTime = date.toLocaleTimeString("en-US", {
      //   hour: '2-digit', minute: '2-digit', second: '2-digit'
      // })

      // // Extract day from the formatted date
      // const day = formattedDate.match(/\d+/)[0]

      // // Add ordinal suffix to the day
      // const ordinalDay = addOrdinalSuffix(day)

      // // Combine the formatted date, ordinal day, and formatted time
      // const formattedDateTime = `${formattedDate.replace(/\d+/, ordinalDay)} ${formattedTime}`
      // return formattedDateTime

      // Create a Date object from the input string
      const date = new Date(dateStr)
      // Get the day, month, and year components
      let day = date.getDate()
      const monthIndex = date.getMonth()
      const year = date.getFullYear()
      if (day < 10) {
        day = `0${day}`
      }
      // Format the date
      const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`

      const formattedTime = date.toLocaleTimeString("en-US", {
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      })
      const formattedDateTime = `${formattedDate} ${formattedTime}`

      return formattedDateTime
    }
    return ''
  }

  const AmountFormat = (dataArray) => {
    let x = dataArray
    x = Number.parseFloat(x).toFixed(2)
    x = x.toString()
    let afterPoint = ""
    if (x.indexOf(".") > 0) {
      afterPoint = x.substring(x.indexOf("."), x.length)
    }
    x = Math.floor(x)
    x = x.toString()
    let lastThree = x.substring(x.length - 3)
    const otherNumbers = x.substring(0, x.length - 3)
    if (otherNumbers !== "") {
      lastThree = `,${lastThree}`
    }
    const res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint
    if (res) {
      return `${res}`
    } else {
      return ``
    }
  }

  const selectStyles = {
    container: (provided) => ({
      ...provided,
      marginTop: 0
    }),
    valueContainer: (provided) => ({
      ...provided,
      overflow: "visible"
    }),
    placeholder: (base, state) => ({
      ...base,
      position: "absolute",
      top: (state.hasValue || state.selectProps.inputValue || state.selectProps.menuIsOpen) ? '-45%' : '20%',
      transition: 'top 0.2s, font-size 0.2s',
      fontSize: (state.hasValue || state.selectProps.inputValue || state.selectProps.menuIsOpen) && 14,
      background: "#fff",
      padding: "0 5px",
      fontWeight: 500,
      color: '#000'
    })
  }

  const GetUserData = () => {
    const userData = getUser()
    if (userData) {
      const userName = userData
      return `${userName.firstName} ${userName.lastName}`
    }
    return ''
  }

  const getYear = (date) => {
    const year = date.getFullYear()
    return `${year}`
  }

  const myEncodeURIComponent = (value) => {
    return encodeURIComponent(value)
  }
  const vaultUrl = (fileReferenceNumber) => {
    const hostname = window.location.hostname
    let env = "" // Default to production

    if (hostname.includes("dev") || hostname.includes("localhost")) {
      env = "-dev"
    } else if (hostname.includes("stg")) {
      env = "-stg"
    } else if (hostname.includes("tst")) {
      env = "-tst"
    }
    return `https://vault${env}.liscr.com/filePreview/${fileReferenceNumber}`
  }

  const handlePreviewClick = (fileReferenceNumber, link) => {
    const url = vaultUrl(fileReferenceNumber)
    if (!link) {
      window.open(url, "_blank")
    } else {
      return url
    }

  }

  const no80BroadRuleMsg = 'Address containing "80 Broad" is not allowed'
  // const validationPattern = /\b80[\W_]*broads?\b|\b80broads?\b/i
  const validationPattern = /\b80 broad\b/i
  const no80BroadRule = () => yup.string().nullable().test('no-80-broad', no80BroadRuleMsg, (value) => {
    if (!value) return true

    const normalized = value.toLowerCase()
    // Matches "80" followed by any number of non-alphanumeric characters, then "broad"
    const forbiddenPattern = validationPattern

    return !forbiddenPattern.test(normalized)
  })

  const renderAddressText = () => {
    return `<b>
              Please contact
              <a href="mailto:corporate@liscr.com" style="text-decoration: underline;">
              corporate@liscr.com
              </a>
              to add the address on this client.
          </b>`
  }

  const isAdminRole = () => {
    const userData = getUser()
    if (userData) {
      const parsedData = userData
      const roles = parsedData?.userRoles
      if (Array.isArray(roles)) {
        return roles.some(role => role.rId === 1)
      }
    }
    return false
  }

  const emailDurationTime = 30 * 1000
  const zoomInOut = { animate: { opacity: 1, scale: 1 }, transition: { duration: 1, delay: 0.1 }, initial: { opacity: 0, scale: 0.5 }, exit: { opacity: 0, scale: 0.5 } }
  const leftToRight = { animate: { x: 0 }, transition: { type: 'slide', stiffness: 120 }, initial: { x: '-100%' }, exit: { x: '100%' } }
  return {
    headerText,
    selectStyles,
    DocusignTitle,
    DocusignTitleDL,
    InvoicePaymentModes,
    InvoicePaymentStatus,
    WOStatus,
    errorresponse,
    authAxios,
    authAxiosMulti,
    sorter,
    datesList,
    monthnames,
    getESTDate,
    DateFormat,
    YearMonthDateFormat,
    YearMonthDateFormatSplit,
    MonthDateYear,
    AmountFormat,
    StringtoDateMonthYearFormat,
    DateTimeConversion,
    DateConversion,
    ReplaceString,
    emailDurationTime,
    zoomInOut,
    leftToRight,
    myEncodeURIComponent,
    getYear,
    stepperValue,
    validCss,
    invalidCss,
    customCss,
    postalCodeMin,
    postalCodeMax,
    specialCharacterErrorMessage,
    hashCharacterPattern,
    postalCodeErrorMessaage,
    CreditCardNote,
    PaymentInstructions,
    specialCharacterPattern,
    myDecodeURIComponent,
    CreditCardpercentage,
    preorderInvoiveTitle,
    GetUserData,
    sortByLabel,
    requestByValidationMessage,
    handlePreviewClick,
    responsibleOffices,
    offices,
    entityMappings,
    no80BroadRule,
    no80BroadRuleMsg,
    renderAddressText,
    validationPattern,
    isAdminRole
  }
}
